import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import capitalize from 'lodash/capitalize';
import Segment from '../Segment';
import Grid from '../Grid';
import Button from '../Button';
import Image from '../Image';
import LockImage from '../SubscriptionModule/Lock.svg';
import messages from './messages';

import './styles.css';

class LockedSegment extends React.PureComponent {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    onUpgradeClick: PropTypes.func,
  };

  getVersion = () => (this.props.pathname.split('/').pop());

  getSubheader = (version) => {
    switch (version) {
      case 'competitors': return messages.lockedCompetitorsSubheader;
      case 'majors': return messages.lockedMajorsSubheader;
      case 'diversity': return messages.lockedDiversitySubheader;
      default: return messages.lockedDefaultSubheader;
    }
  }

  render() {
    const version = this.getVersion();
    const subheaderMessage = this.getSubheader(version);

    return (
      <Segment styleName="locked-segment" data-cy="advance-awareness-unlock-diversity-screen">
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <h1><FormattedMessage {...messages.lockedHeader} values={{ version: capitalize(version) }} /></h1>
              <p><FormattedMessage {...subheaderMessage} /></p>
            </Grid.Column>
            <Grid.Column width={4}>
              <Image src={LockImage} aria-hidden="true" styleName="premium-lock-large" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button
                type="button"
                secondary
                onClick={this.props.onUpgradeClick}
                styleName="upgrade-button"
                id="locked-upgrade-button"
              >
                <FormattedMessage {...messages.lockedUpgrade} />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default LockedSegment;
